import type { ReactNode } from 'react';
import type {
  AnySpec,
  KindMap,
  KindOf,
  SpecOf
} from 'v5/core/form-schema/formKinds.types';
import type { FormKit } from './schemaForm.types';

export type RenderFieldProps<M extends KindMap<M>> = {
  kit: FormKit<M>;
  spec: AnySpec<M>;
  path: string;
  hideLabel?: boolean;
};

function renderKind<M extends KindMap<M>, K extends KindOf<M>>(
  kit: FormKit<M>,
  spec: SpecOf<M, K>,
  path: string,
  hideLabel: boolean | undefined
): ReactNode {
  const { Component } = kit[spec.kind];
  return <Component spec={spec} path={path} hideLabel={hideLabel} />;
}

/** The kit's component for `spec.kind`. */
export function RenderField<M extends KindMap<M>>({
  kit,
  spec,
  path,
  hideLabel
}: RenderFieldProps<M>): ReactNode {
  return renderKind(kit, spec, path, hideLabel);
}
